<template>
  <div style="width: 100%; margin-top: -70px">
    <Banner />
    <component
      :is="item.cardType"
      v-for="item in moduleList"
      :key="item.code"
      :moduleData="item"
    />

    <!-- 示意图 -->
    <!-- <div style="width: 100%;height: 70px;background: #337DD4"></div>
    <img class="w100" :src="`${baseUrl}images/home.jpg`"> -->
  </div>
</template>

<script>
import Banner from "@/components/office/Banner";
import CARD from "@/components/office/CARD";
import TOPIC from "@/components/office/TOPIC";
import TOPICDL from "@/components/office/TOPICDL";
import SUBJECT from "@/components/office/SUBJECT";
import SUBJECTDL from "@/components/office/SUBJECTDL";
import COMMENT from "@/components/office/COMMENT";
import LINK from "@/components/office/LINK";
import LINKMAGA from "@/components/office/LINKMAGA";
import { getPageDeskVo } from "@/api/home/home";
import { getRedirect } from "@/api/login";

export default {
  name: "Office",
  props: [],
  components: {
    Banner,
    CARD,
    SUBJECT,
    TOPIC,
    COMMENT,
    LINK,
    LINKMAGA,
    SUBJECTDL,
    TOPICDL,
  },
  data() {
    return {
      baseUrl: process.env.BASE_URL,
      moduleList: [],
    };
  },
  computed: {},
  created() {},
  mounted() {
    this.getPageDeskVo();
    this.getRedirect();
  },
  destroyed() {},
  methods: {
    getPageDeskVo() {
      getPageDeskVo().then(({ data }) => {
        if (data.code == 0) {
          this.moduleList = data.data.cards;
          this.moduleList.forEach(item => {
            if (item.cardType == "CARD") {
              item.type = "index";
            }
          });
        } else {
          this.$message.error(data.msg);
        }
      });
    },
    //获取重定向数据
    getRedirect(){
      getRedirect().then(res=>{
        if(res.data.success&&res.data.data.params){
          this.$router.push({
            path:'/ServeCenterDetail',
            query: { id:res.data.data.params},
          })
        }
      })
    }
  },
  watch: {},
  filters: {},
};
</script>

<style scoped></style>
